document.addEventListener('DOMContentLoaded', () => {

  const sections = document.querySelectorAll(
    '.shopify-section:not(.shopify-section-group-header-group)'
  );

  if (!sections.length) return;

  /*
   * Respect du réglage d'accessibilité de l'utilisateur.
   */
  const reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  if (reduceMotion || !('IntersectionObserver' in window)) {
    sections.forEach((section) => {
      section.classList.add('custom-visible');
    });

    return;
  }

  const observer = new IntersectionObserver(
    (entries, currentObserver) => {

      entries.forEach((entry) => {

        if (!entry.isIntersecting) return;

        entry.target.classList.add('custom-visible');

        currentObserver.unobserve(entry.target);

      });

    },
    {
      threshold: 0.08,
      rootMargin: '0px 0px -30px 0px'
    }
  );

  sections.forEach((section) => {

    section.classList.add('custom-reveal');

    observer.observe(section);

  });

});